export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/IssueIllustration.2a840f13.svg","height":192,"width":343,"blurWidth":0,"blurHeight":0};